import { render } from "./TabViewMovimiento.vue?vue&type=template&id=34f04246"
import script from "./TabViewMovimiento.vue?vue&type=script&lang=js"
export * from "./TabViewMovimiento.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__